export default {
  data () {
    return {
      rules: {
        required: v => {
          if (typeof v === 'string') {
            return !!v.trim() || 'Vyplňte prosím toto pole.'
          } else
          if (Array.isArray(v)) {
            return !!v.length || 'Vyplňte prosím toto pole.'
          } else {
            return (!!v || v === 0) || 'Vyplňte prosím toto pole.'
          }
        },
        checked: v => !!v || 'Prosím potvrďte, že data byla zkontrolována.',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Neplatná hodnota.',
        phone: v => {
          v = v || ''
          return v.length ? /^[0-9+][0-9 ]*$/.test(v) || 'Neplatná hodnota.' : true
        },
        number: v => v.length ? /^[0-9]+$/.test(v) || 'Neplatná hodnota.' : true,
        floatNumber: v => (/^[0-9.]+$/.test(v.trim()) && isFinite(+v)) || 'Neplatná hodnota.',
        tos: v => !!v || 'Musíte souhlasit s obchodními podmínkami.',
        minLength: min => v => v.length ? v.length >= min || `Musí obsahovat alespoň ${min} znaků.` : true,
        maxLength: max => v => v.length ? v.length <= max || `Nesmí obsahovat více než ${max} znaků.` : true,
        maxSize: bytes => v => (v ? v.size : 0) <= bytes || 'Soubor je příliš velký.',
        moneyMin: min => v => v >= min || 'Zadejte částku',
        greaterThan: num => v => v > num || `Musí být větší než ${num}.`,
        lessThan: num => v => v < num || `Musí být menší než ${num}.`
      }
    }
  }
}
